var map = {
	"./404.svg": "Tp9B"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CEO5";


//////////////////
// WEBPACK FOOTER
// ./src/utils/icons/svg nonrecursive \.svg$
// module id = CEO5
// module chunks = 32